import { useMemo } from "react"

import { useParams } from "react-router-dom"

import { CatalogItemsCount, CatalogItemsCountSkeleton } from "@l2r-front/l2r-ui"
import { formatMetersToDistance } from "@l2r-front/l2r-utils"

import { useRoadsideStateContext } from "../../contexts/RoadsideContext"
import { useRoadsideInventoryTypesStats } from "../../hooks/queries/useRoadsideInventoryTypesStats"
import { useRoadsideTypes } from "../../hooks/queries/useRoadsideTypes"

type RoadsideCountProps = {
    className?: string
    displayTotalCount?: boolean
    isMainCount?: boolean
    signType?: string
}

export function RoadsideCount(props: RoadsideCountProps) {

    const {
        className,
        displayTotalCount,
        isMainCount,
        signType,
    } = props

    const { road } = useParams()
    const { filters } = useRoadsideStateContext()

    const apiFilters = {
        ...filters?.conditions?.length && { condition: filters.conditions },
        ...(road && { linear_location_road: road }),
    }

    const { data: dataWithFilters,
        isError: dataWithFiltersError,
        isLoading: dataWithFiltersLoading,
    } = useRoadsideInventoryTypesStats({ ...apiFilters })

    const {
        data: dataWithoutConditionFilters,
        isError: dataWithoutConditionFiltersError,
        isLoading: dataWithoutConditionFiltersLoading,
    } = useRoadsideInventoryTypesStats({ ...(road && { linear_location_road: road }) })
    const {
        data: roadsideTypes,
        isError: isErrorRoadsideTypes,
        isLoading: isLoadingRoadsideTypes,
    } = useRoadsideTypes()

    const calculatedCount = useMemo(() => {
        if (signType) {
            return dataWithFilters?.length?.[signType] || 0
        } else if (dataWithFilters && roadsideTypes) {
            return roadsideTypes.reduce((acc, roadsideType) => {
                return acc + (dataWithFilters?.length?.[roadsideType.code] || 0)
            }, 0)
        } else {
            return 0
        }
    }, [dataWithFilters, roadsideTypes, signType])

    if (dataWithFiltersError || dataWithoutConditionFiltersError || isErrorRoadsideTypes) {
        return null
    }

    if (dataWithFiltersLoading || dataWithoutConditionFiltersLoading || isLoadingRoadsideTypes) {
        return <CatalogItemsCountSkeleton className={className} isMainCount={isMainCount} />
    }

    return <CatalogItemsCount
        className={className}
        filteredCount={formatMetersToDistance(calculatedCount, 2)}
        formatNumbers={false}
        isMainCount={isMainCount}
        totalCount={displayTotalCount && formatMetersToDistance(Number(dataWithoutConditionFilters?.length?.[signType]), 2)}
    />
}
